import { CIcon } from '~/icons/types'
export const ciTent: CIcon = {
  name: 'tent',
  type: 'light',
  width: 512.002,
  height: 512.002,
  paths: [
    {
      d:
        'm510.392 363.189-54.006-79.837v-.119L350.295 134.199H169.094L58.033 283.114v.137L1.714 363.035c-2.983 4.225-1.974 10.072 2.251 13.054a9.328 9.328 0 0 0 5.393 1.714 9.35 9.35 0 0 0 7.662-3.965l41.013-58.103v62.069H456.39v-61.016l38.484 56.901a9.361 9.361 0 0 0 7.767 4.115c1.806 0 3.63-.52 5.238-1.608a9.364 9.364 0 0 0 2.513-13.007zm-345.968-4.119H76.762v-69.735l87.662-117.551V359.07zm97.928.004h-79.194v-185.32l79.194 115.374v69.946zm-70.77-206.146h149.061l88.217 123.93H276.648l-85.066-123.93zm246.076 206.146H281.085v-63.483h156.573v63.483z',
      fill: 'currentColor'
    }
  ]
}
